// 用户行为 0访问 1复制 2点击 3曝光
export const DEED_MAP = {
  VISITED: 0,
  COPY: 1,
  CLICK: 2,
  EXPOSURE: 3,
};
// 事件编号
export const OID_MAP = {
  PAGE_SEARCH_VISITED: 795, // 搜索页被浏览
  POPUP_SEARCH_CLASSIFY_SELECT: 1144, // 搜索分类选择
  SEARCH: 852, // 搜索
  MORE_COMPANY_CLICK: 889, // 更多公司 点击
  RELATED_COMPANY_CLICK: 891, // 相关公司 点击
  SEARCH_HISTORY_EXPOSURE: 1166, // 搜索历史曝光
  SEARCH_HISTORY_CLICK: 1167, // 搜索历史点击

  RELATED_SEARCH_EXPOSURE: 735, // 同行在搜
  RELATED_SEARCH_CLICK: 736,
  RELATED_SEARCH_REFRESH: 737,

  EXPAND_SEARCH_KEYWORDS_AIMED: 1179, // 拓展搜索词命中
  EXPAND_SEARCH_KEYWORDS_CHECKED: 1180, // 拓展搜索词勾选

  NEWBIE_TASK_SIDEBAR_ENTRY_CLICK: 1072, // 新手任务侧边栏入口点击
  NEWBIE_TASK_GO_TO_SEARCH_CLICK: 1073, // 新手任务 去搜索 点击
  NEWBIE_TASK_GO_TO_MONITOR_CLICK: 1074, // 新手任务 去监控 点击
  NEWBIE_TASK_GO_TO_SUBSCRIBE_CLICK: 1075, // 新手任务 去订阅 点击
  HELP_CENTER_EXPOSURE: 1076, // 帮助中心显示
  NEWBIE_TASK_HELP_CENTER_ENTRY_CLICK: 1077, // 完成新手任务 入口点击
  HELP_CENTER_VIDEO_TUTORIAL_CLICK: 1078, // 视频教程 点击
  HELP_CENTER_MANUAL_CLICK: 1079, // 操作手册 点击
  HELP_CENTER_MANUAL_VISITED: 1081, // 操作手册 页面访问 // todo

  INDUSTRY_ZONE_PROPERTY_MANAGEMENT_EXPOSURE: 1104, // 行业专区 物业 曝光
  INDUSTRY_ZONE_PROPERTY_MANAGEMENT_ENTRY_CLICK: 1105, // 行业专区 物业 进入专区 点击
  INDUSTRY_ZONE_PROPERTY_MANAGEMENT_VIEW_MORE_CLICK: 1106, // 行业专区 物业 查看更多信息 点击
  INDUSTRY_ZONE_PROPERTY_MANAGEMENT_TAB_TITLE_CLICK: 1107, // 行业专区 物业 右侧信息栏tab切换
  INDUSTRY_ZONE_PROPERTY_MANAGEMENT_BOARD_NEWS_CLICK: 1108, // 行业专区 物业 右侧信息栏 信息点击
  SMART_SUBSCRIBE_EXPOSURE: 1132, // 智能订阅 曝光

  SEARCH_NEWAREA_CLICK: 1089, // 大搜索地区 点击
  SEARCH_PURCHASING_CLICK: 934, // 大搜索采购单位 点击
  SEARCH_TYPEALL_CLICK: 1123, // 大搜索综合信息类型点击
  SEARCH_INDUSTRY_CLICK: 1140, // 大搜索行业分类点击
  SEARCH_TIMETYPE_CLICK: 1090, // 大搜索选择时间点击

  SEARCH_VIPBIDDINGTYPE_CLICK: 935, // 大搜索VIP筛选招标方式
  SEARCH_VIPBIDDINGTYPE_OPEN_CLICK: 936, //大搜索VIP筛选招标方式公开招标
  SEARCH_VIPBIDDINGTYPE_INCITE_CLICK: 937, // 大搜索VIP筛选招标方式邀请招标
  SEARCH_VIPBIDDINGTYPE_COMPET_CLICK: 938, // 大搜索VIP筛选招标方式竞争性谈判/磋商
  SEARCH_VIPBIDDINGTYPE_SINGLE_CLICK: 939, // 大搜索VIP筛选招标方式单一来源
  SEARCH_VIPBIDDINGTYPE_ELECTRON_CLICK: 940, // 大搜索VIP筛选招标方式电子卖场

  SEARCH_VIPFUNDSOURCE_CLICK: 942, // 大搜索VIP筛选-资金来源点击
  SEARCH_VVIPFUNDSOURCE_FINANCE_CLICK: 943, // 大搜索VIP筛选-财政资金
  SEARCH_VIPFUNDSOURCE_SPECIAL_CLICK: 944, // 大搜索VIP筛选-专项资金及债券
  SEARCH_VIPFUNDSOURCE_BANK_CLICK: 945, // 大搜索VIP筛选-银行贷款
  SEARCH_VIPFUNDSOURCE_INVEST_CLICK: 946, // 大搜索VIP筛选-投资/融资
  SEARCH_VIPFUNDSOURCE_RAISE_CLICK: 947, // 大搜索VIP筛选-单位自筹

  SEARCH_VIPAGENT_CLICK: 949, // 大搜索VIP筛选-代理机构点击

  SEARCH_VIPREGISTRATION_CLICK: 713, // 大搜索VIP筛选-报名时间点击
  SEARCH_VIPREGISTRATION_NOTOVER_CLICK: 714, // 大搜索VIP筛选-报名时间未结束点击
  SEARCH_VIPREGISTRATION_OVER_CLICK: 715, // 大搜索VIP筛选-报名时间结束点击

  SEARCH_VIPAMOUNT_CLICK: 716, // 大搜索VIP筛选-筛选金额
  SEARCH_VIPAMOUNT_TEN_CLICK: 717, // 大搜索VIP筛选-筛选金额10万以下
  SEARCH_VIPAMOUNT_FIFTY_CLICK: 718, // 大搜索VIP筛选-筛选金额10万-50万
  SEARCH_VIPAMOUNT_HUNDRED_CLICK: 719, // 大搜索VIP筛选-筛选金额50万-100万
  SEARCH_VIPAMOUNT_TOWHUNDRED_CLICK: 720, // 大搜索VIP筛选-筛选金额100万-200万
  SEARCH_VIPAMOUNT_FIVEHUNDRED_CLICK: 721, // 大搜索VIP筛选-筛选金额200万-500万
  SEARCH_VIPAMOUNT_UPFIVEHUNDRED_CLICK: 722, // 大搜索VIP筛选-筛选金额500万以上
  SEARCH_VIPAMOUNT_CUSTOM_CLICK: 1121, // 大搜索VIP筛选-筛选金额自定义

  SEARCH_VIPHASPHONE_CLICK: 723, // 大搜索VIP筛选-联系方式
  SEARCH_VIPHASPHONE_BIDDING_CLICK: 724, // 大搜索VIP筛选-有招标联系方式
  SEARCH_VIPHASPHONE_WINBIDDING_CLICK: 725, // 大搜索VIP筛选-有中招标联系方式

  SEARCH_VIPHASLINKNAME_CLICK: 825, // 大搜索VIP筛选-联系人
  SEARCH_VIPHASLINKNAME_BIDDING_CLICK: 826, // 大搜索VIP筛选-有招标联系人
  SEARCH_VIPHASLINKNAME_WINBIDDING_CLICK: 827, // 大搜索VIP筛选-有中招标联系人

  SEARCH_EXCLUDEWORD_CLICK: 856, // 大搜索排除词点击
  SEARCH_RELATEDWORD_CLICK: 857, // 大搜索相似词点击

  SEARCH_VIPFULLTEXT_CLICK: 851, // 大搜索VIP筛选 - 附加搜索 - 搜全文点击
  SEARCH_VIPCOMPANY_CLICK: 831, // 大搜索VIP筛选 - 附加搜索 - 搜公司点击
  SEARCH_VIPSEARCHLINKENAMR_CLICK: 832, // 大搜索VIP筛选 - 附加搜索 - 搜联系人点击
  SEARCH_SENIOR_CLICK: 855, // 大搜索高级按钮

  SEARCH_INFORMATIONTYPE_CLICK: 963, // 大搜索招中标信息类型

  SEARCH_SORT_CLICK: 852, //综合排序和按时间排序
  SEARCH_SORTRELEATE_CLICK: 833, //相关性排序
  SEARCH_BRIEF_CLICK: 1124, //简要
  SEARCH_DETAIL_CLICK: 1125, //明细
  SEARCH_BRIEFTYPE_CLICK: 1146, //简要点击
  SEARCH_DETAILTYPE_CLICK: 1147, //明细点击
  SEARCH_SOLR_CLICK: 870, //solr接口没有结果返回
  SEARCH_NOTSOLR_RETURN: 873, //solr接口不等于200
  SEARCH_OUTTIME_EXPOSURE: 904, //solr接口超时埋点
  SEARCH_SOLRLIST_CLICK: 895, //solr列表的title
  SEARCH_ZTENbING_SELECT: 675, //综合，招标，中标
  SEARCH_PROJECT_SELECT: 677, //拟在建
  SEARCH_APPROVE_SELECT: 678, //审批
  PURCHASER_EXPOSURE: 807, //相似采购商曝光
  SUPPLIER_EXPOSURE: 810, //相似供应商曝光
  PURCHASER_CLICK: 808, //相似采购商點擊
  SEARCH_SIMILAR_UNITS_MORE_CONTACTS_CLICK: 809, //相似采购商點擊
  SEARCH_SIMILAR_UNITS_SUPPLY_MORE_CONTACTS_CLICK: 812, //相似供应商點擊

  SUPPLIER_CLICK: 811, //相似供应商点击
  PEERSEARCH_CLICK: 626, //您的同行在搜点击
  PEERSEARCH_EXPOSURE: 625, //同行在搜新旧埋点不一致展示
  INDUSTRYCLIST_EXPOSURE: 1142, //四级类列表模块展示
  SEARCHCLIST_CLICK: 1141, //点击四级类
  SUBUPDATE_CLICK: 1159, //点击订阅更新
  SEARCHSELECT_CLICK: 1129, //导出选中内容
  SEARCHSELECTALL_CLICK: 1130, //导出全部内容
  SELECTEXPORT_CLICK: 1091, //点击导出按钮
  SEARCH_ENTERPRISE_INFORMATION_EXPOSURE: 679, //企业信息面板曝光
  SEARCH_ENTERPRISE_INFORMATION_BIDWINNING_CLICK: 680, //企业信息面板-招中标数字按钮
  SEARCH_ENTERPRISE_INFORMATION_ENTERPRISE_NAME_CLICK: 681, //企业信息面板-企业名称按钮
  SEARCH_ENTERPRISE_INFORMATION_SEE_MORE_CLICK: 682, //企业信息面板-查看更多
  GET_VIRTUAL_PHONE_CLICK: 687, // 获取中间号点击
  SEARCH_ENTERPRISE_INFORMATION_MORE_CONTACTS_CLICK: 740, //企业信息面板-查看更多
  SEARCH_ENTERPRISE_MORE_CONTACTS_PAYPOPUP_EXPOSURE: 733, //企业信息面板-更多联系人支付弹框曝光
  SEARCH_ENTERPRISE_MORE_CONTACTS_PAIDPOPUP_EXPOSURE: 734, //企业信息面板-更多联系人已支付弹框曝光

  SEARCH_COMPANY_ANALYSE_RIGHT_EXPOSURE: 766, //右侧企业商情曝光
  SEARCH_COMPANY_ANALYSE_RIGHT_CLICK: 767, //右侧企业商情点击

  SEARCH_RECOMMENDED_SUPPLIER_CLICK: 738, //右侧推荐供应商
  FREESEARCH_EXPOSURE: 892, //免费用户公司模块
  COLLECT_COMPANY_CLICK: 729, //收藏公司
  CHANGE_NOTICE_CLICK: 730, //变更通知
  VIEW_BIDDING_INFO_CLICK: 731, //联系人查看公司招投标信息
  QUALITY_SUPPLIER_CLICK: 893, //优质供应商点击链接

  /**个人中心首页 */
  USER_CENTER_ENTERPRISE_MONITORING_MORE_CLICK: 666, //首页企业监控更多点击
  USER_CENTER_ENTERPRISE_MONITORING_INFORMATION_CLICK: 670, //首页企业监控信息点击
  USER_CENTER_ENTERPRISE_MONITORING_NUMBER_CLICK: 671, //首页企业监控更新条数击
  USER_CENTER_MY_COLLECTION_MORE_CLICK: 666, //首页最近收藏企业更多点击//老项目就是这个不是写错
  USER_CENTER_MY_COLLECTION_NAME_CLICK: 665, //首页最近收藏企业名称点击
  USER_CENTER_COLLECTION_MORE_CLICK: 668, //首页最近收藏更多点击
  USER_CENTER_COLLECTION_TITLE_CLICK: 667, //首页最近收藏详情标题点击
  USER_CENTER_MY_VISITED: 1353, // 我的会员页访问埋点

  /**新手引导 */
  NEW_USER_TASK_GRADE_EXPOSURE: 1202, //新手引导banne曝光
  NEW_USER_TASK_GRADE_BANNER_EXPOSURE: 1203, //新手引导banne曝光
  NEW_USER_TASK_GRADE_SAMALL_CLICK: 1204, //新手引小图标点击
  NEW_USER_TASK_GRADE_BANNER_CLICK: 1213, //新手引banner小手点击
  NEW_USER_TASK_GRADE_BOX_EXPOSURE: 1207, //新手引导弹窗曝光
  NEW_USER_TASK_GRADE_CLOSE_CLICK: 1205, //新手引导关闭按钮
  NEW_USER_TASK_GRADE_GIVEUP_CLICK: 1206, //新手引导关闭按钮后的放弃按钮
  NEW_USER_TASK_GRADE_GIVEUP_EXPOSURE: 1198, //新手引导下一步曝光
  NEW_USER_TASK_GRADE_BANNERBOX_EXPOSURE: 1201, //新手引导曝光

  /** 找采购意向埋点  **/
  PURCHASE_INTENTION_PAGE_EXPOSURE: 2039, //找商机-采购意向页面曝光，记录搜产品，搜单位
  PURCHASE_INTENTION_COMMON_SEARCH_SAVE_CLICK: 1249, // 找采购意向 - 常用搜索保存
  PURCHASE_INTENTION_COMMON_SEARCH_CLICK: 2044, //找商机-采购意向通过已保存的常用搜索进行搜索
  PURCHASE_INTENTION_POPULAR_SEARCH_CLICK: 1251, // 找采购意向 - 相关热搜点击 ctx记录点击词
  PURCHASE_INTENTION_AND_OR_RELATIONSHIP_SWITCH: 1252, // 找采购意向 - 且或关系切换 extendinfo记录点击项名称
  PURCHASE_INTENTION_SEARCH: 2040, // 找商机-采购意向搜索，额外记录搜索关键词， 搜索类型 (0搜产品，1搜单位)
  PURCHASE_INTENTION_DETAIL_CLICK: 2041, // 找商机-采购意向点击详情，额外记录cid
  PURCHASE_INTENTION_FREE_TRIAL_CLICK: 2042, // 找商机-采购意向点击免费试用
  PURCHASE_INTENTION_ACTIVATE_NOW_CLICK: 2043, // 找商机-采购意向点击立即开通

  /**找标讯 页面埋点 */
  BIDDING_INFO_PAGE_VIEW: 1227, // 找标讯 页面访问
  BIDDING_INFO_SEARCH: 1228, // 找标讯 搜索
  BIDDING_INFO_FILTER_TIME_CLICK: 1229, //找标讯 - 搜索条件-时间条件点击
  BIDDING_INFO_FILTER_AREAS_CLICK: 1230, //找标讯 - 搜索条件-地区条件点击
  BIDDING_INFO_FILTER_TYPE_TENDER_CLICK: 1231, //找标讯 - 搜索条件-信息类型条件点击
  BIDDING_INFO_FILTER_PURCHASINGA_UNITLD_CLICK: 1232, //找标讯 - 搜索条件-采购单位条件点击
  BIDDING_INFO_FILTER_PURCHASINGA_CATEGORY_CLICK: 1233, //找标讯 - 搜索条件-采购类别条件点击
  BIDDING_INFO_FILTER_PROJEC_AMOUNT_CLICK: 1234, //找标讯 - 搜索条件-项目金额条件点击
  BIDDING_INFO_FILTER_SEARCHSCOPE_CLICK: 1235, //找标讯 - 搜索条件-搜索范围条件点击
  BIDDING_INFO_FILTER_EXCLUDE_WORD_CLICK: 1236, //找标讯 - 搜索条件-排除词条件点击
  BIDDING_INFO_FILTER_BIDDING_TYPE_CLICK: 1237, //找标讯 - 搜索条件-招标方式条件点击
  BIDDING_INFO_FILTER_DEADLINE_CLICK: 1238, //找标讯 - 搜索条件-截止时间条件点击
  BIDDING_INFO_FILTER_HAS_PHONE_CLICK: 1239, //找标讯 - 搜索条件-联系电话条件点击
  BIDDING_INFO_FILTER_HAS_LINK_NAME_CLICK: 1240, //找标讯 - 搜索条件-联系人条件点击
  BIDDING_INFO_FILTER_FUNDS_SOURCE_LIST_CLICK: 1241, //找标讯 - 搜索条件-资金来源条件点击
  BIDDING_INFO_FILTER_FUNDS_HASAGENT_CLICK: 1242, //找标讯 - 搜索条件-代理机构条件点击
  BIDDING_INFO_FILTER_SEARCH_MOUDE_CLICK: 1243, //找标讯 - 搜索条件-搜索模式条件点击

  BIDDING_INFO_COMMON_SEARCH_SAVE_CLICK: 1249, // 找标讯 - 常用搜索保存
  BIDDING_INFO_COMMON_SEARCH_CLICK: 1250, // 找标讯 - 常用搜索点击 extendinfo记录常用搜索的数据库id
  BIDDING_INFO_POPULAR_SEARCH_CLICK: 1251, // 找标讯 - 相关热搜点击 ctx记录点击词
  BIDDING_INFO_AND_OR_RELATIONSHIP_SWITCH: 1252, // 找标讯 - 且或关系切换 extendinfo记录点击项名称

  BIDDING_INFO_LIST_SORT_CLICK: 1244, // 找标讯 - 排序点击 extendinfo记录点击项名称
  BIDDING_INFO_LIST_EXPORT_CLICK: 1245, // 找标讯 - 导出点击 extendinfo记录点击项名称
  BIDDING_INFO_LIST_BRIEF_DETAILS_CLICK: 1246, // 找标讯 - 导出点击 extendinfo记录点击项名称
  BIDDING_INFO_LIST_COLLECTION_CLICK: 1247, // 找标讯 - 收藏点击 extendinfo记录点击项名称
  BIDDING_INFO_LIST_ITEM_CLICK: 1248, // 找标讯 - 列表点击 extendinfo记录点击项名称

  /**拟在建 页面埋点 */
  CONSTR_PROJECT_PAGE_VIEW: 1253, // 拟在建 页面访问
  CONSTR_PROJECT_SEARCH: 1254, // 拟在建 搜索
  CONSTR_PROJECT_FILTER_AREAS_CLICK: 1255, //拟在建 - 搜索条件-地区条件点击
  CONSTR_PROJECT_FILTER_INDUSTRY_TYPE_CLICK: 1256, //拟在建 - 搜索条件-项目类别件点击
  CONSTR_PROJECT_FILTER_PROGRESS_STAGE_IDS_CLICK: 1257, //拟在建 - 搜索条件-项目进展件点击
  CONSTR_PROJECT_FILTER_TIME_CLICK: 1258, //拟在建 - 搜索条件-时间条件点击
  CONSTR_PROJECT_FILTER_DECORATION_STATUS_CLICK: 1259, //拟在建 - 搜索条件-装修情况条件点击
  CONSTR_PROJECT_FILTER_OWNER_TYPE_CLICK: 1260, //拟在建 - 搜索条件-业主类型条件点击
  CONSTR_PROJECT_FILTER_STAR_NUM_CLICK: 1261, //拟在建 - 搜索条件-推荐程度条件点击
  CONSTR_PROJECT_FILTER_FILTER_MODE_CLICK: 1262, //拟在建 - 搜索条件-搜素范围条件点击
  CONSTR_PROJECT_FILTER_KEY_WORD_CLICK: 1263, //拟在建 - 搜索条件-关键字条件点击
  CONSTR_PROJECT_FILTER_AND_OR_RELATIONSHIP_SWITCH: 1264, //拟在建 - 搜索条件-关键字切换 点击
  CONSTR_PROJECT_FILTER_EXCLUDE_WORD_CLICK: 1265, //拟在建 - 搜索条件-排除词条件点击

  CONSTR_PROJECT_COMMON_SEARCH_SAVE_CLICK: 1270, // 拟在建 - 常用搜索保存
  CONSTR_PROJECT_COMMON_SEARCH_CLICK: 1271, // 拟在建 - 常用搜索点击 extendinfo记录常用搜索的数据库id
  CONSTR_PROJECT_LIST_SORT_CLICK: 1266, // 拟建搜索-排序点击：extendinfo记录点击项名称
  CONSTR_PROJECT_LIST_EXPORT_CLICK: 1267, // 拟建搜索-导出点击：extendinfo记录导出范围的选项 （标讯搜索的导出oid1245也这么记）
  CONSTR_PROJECT_LIST_COLLECTION_CLICK: 1268, //  拟建搜索-收藏点击
  CONSTR_PROJECT_LIST_ITEM_CLICK: 1269, // 拟建搜索-列表点击：：cid记录content_id

  /** 审批搜索 */
  EXAMINE_PROJECT_FILTER_TIME_CLICK: 1274, //审批搜索-发布时间条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_AREAS_CLICK: 1275, // 审批搜索-业务地区条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_TYPE_TENDER_CLICK: 1276, // 审批搜索-进展阶段条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_SEARCHSCOPE_CLICK: 1277, // 审批搜索-搜索范围条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_SEARCH_MOUDE_CLICK: 1278, // 审批搜索-搜索模式条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_KEY_WORD_CLICK: 1279, // 审批搜索-关键词搜索按钮点击：ctx记录搜索词
  EXAMINE_PROJECT_FILTER_AND_OR_RELATIONSHIP_SWITCH: 1280, //审批搜索-关键词且或关系条件点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_FILTER_EXCLUDE_WORD_CLICK: 1281, // 审批搜索-排除词搜索按钮点击：ctx记录排除词
  EXAMINE_PROJECT_COMMON_SEARCH_SAVE_CLICK: 1286, // 审批搜索 - 常用搜索保存
  EXAMINE_PROJECT_COMMON_SEARCH_CLICK: 1287, // 审批搜索 - 常用搜索点击 extendinfo记录常用搜索的数据库id

  EXAMINE_PROJECT_PAGE_VIEW: 1272, // 审批搜索-页面访问
  EXAMINE_PROJECT_SEARCH: 1273, // 审批搜索-搜索触发
  EXAMINE_PROJECT_LIST_SORT_CLICK: 1282, // 审批搜索-排序点击：extendinfo记录点击项名称
  EXAMINE_PROJECT_LIST_EXPORT_CLICK: 1283, // 审批搜索-导出点击：extendinfo记录导出范围的选项 （标讯搜索的导出oid1245也这么记
  EXAMINE_PROJECT_LIST_COLLECTION_CLICK: 1284, //  审批搜索-收藏点击
  EXAMINE_PROJECT_LIST_ITEM_CLICK: 1285, // 审批搜索-列表点击：：cid记录content_id

  /** 订阅相关 **/
  SUBSCRIBE_INFO_BIDDING_INFO_VIEW: 1292, // 新版订阅-标讯订阅信息页访问：extendinfo记录订阅器id
  SUBSCRIBE_INFORMATION_BIDDING_INFO_LIST_CLICK: 1293, //标讯-公告模式列表点击
  SUBSCRIBE_INFO_BIDDING_INFO_KEYWORD_SELECT: 1294, // 新版订阅-标讯订阅信息页-关键词条件点击
  SUBSCRIBE_INFO_BIDDING_INFO_INFO_TYPE_SELECT: 1295, // 新版订阅-标讯订阅信息页-信息类型条件点击
  SUBSCRIBE_INFO_BIDDING_INFO_TENDER_OR_BIDDER_NAME_SEARCH: 1296, // 新版订阅-标讯订阅信息页-全文查询搜索按钮点击：ctx记录搜索词
  SUBSCRIBE_INFO_BIDDING_INFO_DATE_TYPE_SELECT: 1297, // 新版订阅-标讯订阅信息页-时间条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_AREAS_SELECT: 1298, //  新版订阅-标讯订阅信息页-地区条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_PURCHASING_UNIT_SELECT: 1299, //  新版订阅-标讯订阅信息页-采购单位条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_PURCHASE_TYPE_SELECT: 1300, //  新版订阅-标讯订阅信息页-采购类别条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_AMOUNT_SELECT: 1301, //  新版订阅-标讯订阅信息页-项目金额条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_BIDDING_TYPE_SELECT: 1302, //  新版订阅-标讯订阅信息页-招标方式条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_DEADLINE_SELECT: 1303, //  新版订阅-标讯订阅信息页-截止时间条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_HAS_LINK_NAME_SELECT: 1304, //  新版订阅-标讯订阅信息页-联系人条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_HAS_PHONE_SELECT: 1305, //  新版订阅-标讯订阅信息页-联系电话条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_FUNDS_SOURCE_LIST_SELECT: 1306, //  新版订阅-标讯订阅信息页-资金来源条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_BIDDING_INFO_HAS_AGENT_SELECT: 1307, //  新版订阅-标讯订阅信息页-代理机构条件点击：extendinfo记录点击项名称

  SUBSCRIBE_INFORMATION_BIDDING_INFO_LIST_SORT_CLICK: 1308, //标讯-公告模式排序方式extendinfo记录点击项名称
  SUBSCRIBE_INFORMATION_BIDDING_INFO_LIST_DETAIL_CLICK: 1309, //标讯-公告模式排序方式extendinfo记录点击项名称
  SUBSCRIBE_INFORMATION_BIDDING_INFO_LIST_EXPORT_CLICK: 1310, //讯-公告模式-导出点击：extendinfo记录导出范围的选项

  SUBSCRIBE_INFO_CONSTR_PROJECT_VIEW: 1311, // 新版订阅-拟建订阅信息页访问：extendinfo记录订阅器id
  SUBSCRIBE_INFO_CONSTR_PROJECT_LIST_CLICK: 1312, // 新版订阅-拟建订阅信息页-内容列表点击：cid记录点击内容contentid
  SUBSCRIBE_INFO_CONSTR_PROJECT_PROGRESS_STAGE_SELECT: 1313, // 新版订阅-拟建订阅信息页-进展阶段条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_CONSTR_PROJECT_TENDER_OR_BIDDER_NAME_SEARCH: 1314, // 新版订阅-拟建订阅信息页-全文查询条件点击：ctx记录搜索词
  SUBSCRIBE_INFO_CONSTR_PROJECT_DATE_TYPE_SELECT: 1315, // 新版订阅-拟建订阅信息页-时间条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_CONSTR_PROJECT_INDUSTRY_TYPE_SELECT: 1316, // 新版订阅-拟建订阅信息页-行业类别条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_CONSTR_PROJECT_AREAS_SELECT: 1317, // 新版订阅-拟建订阅信息页-地区条件点击：extendinfo记录点击项名称

  SUBSCRIBE_INFO_CONSTR_PROJECT_SORT_SELECT: 1318, // 新版订阅-拟建订阅信息页-排序方式点击：extendinfo记录点击项名称
  // SUBSCRIBE_INFO_CONSTR_PROJECT_DETAIL_SELECT: 1319, // 新版订阅-拟建订阅信息页-简要明细点击：extendinfo记录点击项名称  拟建也没简要明细
  SUBSCRIBE_INFO_CONSTR_PROJECT_EXPORT_CLICK: 1320, // 新版订阅-拟建订阅信息页-导出按钮点击：extendinfo记录导出范围的选项

  SUBSCRIBE_INFO_EXAMINE_PROJECT_VIEW: 1321, // 新版订阅-审批订阅信息页访问：extendinfo记录订阅器id
  SUBSCRIBE_INFO_EXAMINE_PROJECT_LIST_CLICK: 1322, // 新版订阅-审批订阅信息页-内容列表点击：cid记录点击内容contentid
  SUBSCRIBE_INFO_EXAMINE_PROJECT_KEYWORD_SELECT: 1323, // 新版订阅-审批订阅信息页-关键词条件点击
  SUBSCRIBE_INFO_EXAMINE_PROJECT_PROGRESS_STAGE_SELECT: 1324, // 新版订阅-审批订阅信息页-进展阶段条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_EXAMINE_PROJECT_TENDER_OR_BIDDER_NAME_SEARCH: 1325, // 新版订阅-审批订阅信息页-全文查询条件点击：ctx记录搜索词
  SUBSCRIBE_INFO_EXAMINE_PROJECT_DATE_TYPE_SELECT: 1326, // 新版订阅-审批订阅信息页-时间条件点击：extendinfo记录点击项名称
  SUBSCRIBE_INFO_EXAMINE_PROJECT_AREAS_SELECT: 1327, // 新版订阅-审批订阅信息页-地区条件点击：extendinfo记录点击项名称

  SUBSCRIBE_INFO_EXAMINE_PROJECT_SORT_SELECT: 1328, // 新版订阅-审批订阅信息页-排序方式点击：extendinfo记录点击项名称
  // SUBSCRIBE_INFO_EXAMINE_PROJECT_DETAIL_SELECT: 1329, // 新版订阅-审批订阅信息页-简要明细点击：extendinfo记录点击项名称   审批没简要明细
  SUBSCRIBE_INFO_EXAMINE_PROJECT_EXPORT_CLICK: 1330, // 新版订阅-审批订阅信息页-导出按钮点击：extendinfo记录导出范围的选项
  SUBSCRIBE_INFO_MEDICAL_CLOUD_ENTRANCE_EXPOSURE: 1337, // 新版订阅-医疗云入口曝光

  /** 订阅信息列表 */
  SUBSCRIBE_INFORMATION_BUSINESS_SEE_MORE: 844, //查看更多按钮
  SUBSCRIBE_INFORMATION_BUSINESS_DEAL_RECENTLY: 845, //商情模式近期成交
  SUBSCRIBE_INFORMATION_BUSINESS_PARTNER: 846, //商情模式合作单位
  SUBSCRIBE_INFORMATION_BUSINESS_VIEW_DETAILS: 847, //查看详情

  SUBSCRIBE_INFORMATION_BUSINESS_CONTACTS: 787, //联系人
  SUBSCRIBE_INFORMATION_BUSINESS_HISTORICAL_BID_WINNING_INFORMATION: 848, //查看企业历史中标信息
  SUBSCRIBE_INFORMATION_BUSINESS_ENTERPRISE_INFORMATION_POPUP_VISITED: 849, //查看企业信息弹曝光

  SUBSCRIBE_INFORMATION_BUSINESS_ENTERPRISE_INFORMATION_POPUP_BUTTON: 850, //查看企业信息弹框按钮
  SUBSCRIBE_INFORMATION_BUSINESS_CONTACTS_EXPOSURE: 843, //商情模式联系人弹框曝光
  SUBSCRIBE_INFORMATION_BUSINESS_CONTACTS_MIDDLE_NUMBER_VISITED: 834, //商情模式联系人弹框曝光
  SUBSCRIBE_INFORMATION_BUSINESS_APPLICATION_CLICK: 841, //标讯-商情模式点击
  SUBSCRIBE_INFORMATION_ANNOUNCEMENT_MODE_CLICK: 842, //标讯-公告模式点击

  /** 标讯创建 */
  SUBSCRIBECREATE_VISIT: 1331, // 标讯创建页访问
  SUBSCRIBECREATE_SAVE_BUTTON_CLICK: 1332, // 标讯创建页-保存按钮点击

  SUBSCRIBE_INFORMATION_NEW_STYLE_SHEET_VISITED: 1342, //订阅器样式2页面访问
  SUBSCRIBE_INFORMATION_NEW_STYLE_SHEET_LIST_CLICK: 1343, //订阅器样式2页面订阅列表点击
  SUBSCRIBE_INFORMATION_NEW_STYLE_SHEET_LIST_PUT_BUTTON_CLICK: 1344, //订阅器样式2页面订阅列表-收起按钮点击【extendinfo记录收起还是展开】

  /** 子账号管理 */
  SUB_ACCOUNT_MANAGE_PAGE_ACCESS: 1347, // 子账号管理页面访问
  SUB_ACCOUNT_MANAGE_GUIDE_EXPOSURE: 1348, // 引导功能曝光，【extendinfo记录记录步骤12】
  SUB_ACCOUNT_MANAGE_GUIDE_ENTRANCE_CLICK: 1349, // 引导入口按钮点击，【extendinfo记录是子账号还是访问额度】

  /** 子账号配额管理 */
  SUB_ACCOUNT_MANAGE_PAGE_QUOTA: 1350, //1350 账号访问额度配置页面访问
  SUB_ACCOUNT_MANAGE_PROMOTE_BUTTON_CLICK: 1351, //1351日访问额度-去提升按钮点击
  SUB_ACCOUNT_MANAGE_OPENING_BUTTON_CLICK: 1352, //1352 临时额度-去开通按钮点击
  //帮助中心浮窗点击
  HELP_CENTER_ICON: 1354,
  HELP_CENTER_BIDDING_INFO: 1364,
  HELP_CENTER_EXAMINE_PROJECT: 1366,
  HELP_CENTER_CONSTR_PROJECT: 1365,
  HELP_CENTER_SUB_BIDDING_INFO: 1364,
  HELP_CENTER_SUB_EXAMINE_PROJECT: 1366,
  HELP_CENTER_SUB_CONSTR_PROJECT: 1365,
  //使用手册反馈
  PRODUCT_MANUAL_CLICK: 1367,

  /** 登录相关 */
  LOGIN_REGISTER_SUPPLIER: 971, //登录页-供应商注册
  LOGIN_REGISTER_PURCHASER: 972, //登录页-采购商注册
  LOGIN_REGISTER_AGENT: 973, //登录页-代理商注册
  LOGIN_TYPE_CLICK: 1358, //埋点需求1358 登录按钮点击【extendinfo记录登录方式：0密码，1验证码】
  LOGIN_TIP_NO_OPEN_PHONE_LOGIN_EXPOSURE: 1359, // 提示账号未开启登录功能弹窗曝光
  LOGIN_PHONE_NUMBER_EXPOSURE: 1360, // 1360 选择账号页面登录【extendfinfo记录账号数量】

  /** 账户管理 */
  ACCOUNT_MANAGE_SECURITY_SWITCH_CLICK: 1357, // 验证码登录开关点击【extendinfo记录开关状态，开1关0】

  /**更多联系人相关*/
  MORE_CONTACTS_EXPOSURE: 1372, // 更多联系人  弹窗曝光
  MORE_CONTACTS_TYPE_FILTER_CLICK: 1373, //更多联系人  手机座机筛选点击【extendinfo记录点击项名称】
  MORE_CONTACTS_SOURCE_OBJECT_TITLE_CLICK: 1374, //更多联系人  来源项目标题点击
  MORE_CONTACTS_SOURCE_OBJECT_EXPOSURE: 1375, //更多联系人  来源项目弹窗曝光
  MORE_CONTACTS_SOURCE_OBJECT_LIST_CLICK: 1376, //更多联系人  来源项目弹窗-列表点击
  MORE_CONTACTS_LINK_CLICK: 1377, //更多联系人  联系TA点击  更多联系人
  /**新签活动落地页-注册相关埋点 使用了1.0重构项目的注册接口以及逻辑*/
  REGISTER_NEW_ACTIVITY_REGIST_EXPOSURE: 1387, //新签活动注册页  页面曝光埋点
  REGISTER_NEW_ACTIVITY_REGIST_CLICK: 1388, //新签活动注册页  注册成功埋点  特殊字段记录：用户名
  /**企业库2.0购买弹框*/
  DIALOG_ENTERPRISE_BUY_EXPOSURE: 1394, //企业库2.0 购买信息弹框曝光
  DIALOG_ENTERPRISE_BUY_BUTTON_CLICK: 1395, //企业库2.0 点击立即开通
  /**子账号购买弹框*/
  DIALOG_SUB_ACCOUNT_BUY_EXPOSURE: 1392, //子账号购买信息弹框 曝光
  DIALOG_SUB_ACCOUNT_BUY_BUTTON_CLICK: 1393, //子账号购买信息弹框 点击立即开通
  /**企业监控页面*/
  ENTERPRISE_MONITORING_MONITORING_LIST_EXPOSURE: 1397, //企业列表曝光
  ENTERPRISE_MONITORING_MONITORING_DYNAMICS_EXPOSURE: 1396, //企业动态曝光
  ENTERPRISE_MONITORING_MONITORING_SETTINGS_EXPOSURE: 1398, //监控设置曝光
  ENTERPRISE_MONITORING_NO_PERMISSION_EXPOSURE: 292, //无权限页面曝光
  ENTERPRISE_MONITORING_IMMEDIATELYACTIVATE_CLICK: 1043, //点击无权限页面立即开通按钮

  ENTERPRISE_PACKAGE_CLICK: 2002, //企业套餐点击
  ABOUT_US_QLM_CLICK: 2003, //关于千里马点击
  HEADER_MEMBER_CLICK: 2006, //顶部会员中心按钮点击
  VIP_LOGIN_PAGE_VISITED: 2011, //登录页面曝光

  /**产品服务*/
  PRODUCTS_SERVICES_HEADER_BOX_EXPOSURE: 2034, //产品服务顶部框曝光2034
  PRODUCTS_SERVICES_BILLBOARD_CLICK: 2020, //产品服务模块-招标查询：2020
  PRODUCTS_SERVICES_VIP_CLICK: 2021, //产品服务模块-VIP独家信息：2021
  PRODUCTS_SERVICES_PROJECT_CLICK: 2022, //产品服务模块-拟在建项目查询：2022
  PRODUCTS_SERVICES_BUSINESS_OPPORTUNITY_PUSH_CLICK: 2023, //产品服务模块-商机推送：2023
  PRODUCTS_SERVICES_COMPANY_ANALYSE_RIGHT_CLICK: 2035, //产品服务模块-企业商情分析：2035
  PRODUCTS_SERVICES_ENTERPRISE_INTELLIGENT_MANAGEMENT_CLICK: 2024, //产品服务模块-企业智能管理：2024
  PRODUCTS_SERVICES_PUBLISH_BIDDING_CLICK: 2025, //产品服务模块-发布招标信息：2025
  PRODUCTS_SERVICES_RECOMMEND_BIDDING_CLICK: 2026, //产品服务模块-推荐招标专区：2026
  PRODUCTS_SERVICES_FINDING_CONNECTIONS_CLICK: 2027, //产品服务模块-找人脉：2027
  PRODUCTS_SERVICES_TUO_KE_BAO_CLICK: 2028, //产品服务模块-拓客宝：2028
  PRODUCTS_SERVICES_REN_MAI_TONG_CLICK: 2029, //产品服务模块-人脉通：2029
  PRODUCTS_SERVICES_QU_DAO_BAO_CLICK: 2030, //产品服务模块-渠道宝：2030
  PRODUCTS_SERVICES_DATA_MALL_CLICK: 2031, //产品服务模块-数据商城：2031
  PRODUCTS_SERVICES_DATA_CUSTOMIZED_CLICK: 2032, //产品服务模块-数据定制：2032

  /**批量导出-crm*/
  BATCH_EXPORT_CRM_BTN_CLICK: 1403, // 导入CRM点击埋点
  BATCH_EXPORT_CRM_INTRODUCE_CLICK: 1404, // 查看详细介绍点击埋点
  BATCH_EXPORT_CRM_CONTACT_CLICK: 1405, //联系我们点击埋点
  /**集成crm*/
  CRM_INTEGRATION_LANDING_PAGE_EXPOSURE: 1406, //落地页曝光
  CRM_INTEGRATION_APPLICATION_OPEN_CLICK: 1407, //报名开通
  CRM_INTEGRATION_APPLICATION_SUBMIT_CLICK: 1408, //确认提交
  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_EXPOSURE: 2045, //采购意向﹣详情页﹣开通会员弹窗曝光
  PURCHASE_INTENTION_FREE_TRIAL_EXPOSURE: 2046, //采购意向﹣详情页﹣领取体验特权弹窗﹣曝光
  PURCHASE_INTENTION_FREE_TRIAL_SUCCESS_EXPOSURE: 2047, //采购意向﹣详情页﹣领取体验特权弹窗﹣成功领取体验
  PURCHASE_INTENTION_FREE_TRIAL_IMMEDIATELY_BUY_CLICK: 2048, //采购意向﹣详情页﹣领取体验特权弹窗﹣点击立即购买
  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_IMMEDIATELY_BUY_CLICK: 2049, //采购意向﹣详情页﹣套餐选择弹窗﹣点击立即购买
  PURCHASE_INTENTION_ACTIVATE_MEMBERSHIP_SUCCESS_EXPOSURE: 2050, //采购意向﹣详情页﹣支付成功，额外记录实付金额
  PURCHASE_INTENTION_SEARCH_UNIT: 2053, // 找商机-采购意向-搜单位，进行二次搜索，额外记录：搜索关键词，二次搜索关键词

  SUBSCRIBE_INFO_PURCHASE_INTENTION_VIEW: 2055, // 新版订阅-采购意向订阅器- 额外记录订阅器名称
  SUBSCRIBE_INFO_PURCHASE_INTENTION_LIST_CLICK: 2056, // 新版订阅-采购意向订阅器-列表数据点击

  MONITOR_DYNAMICS_ALL_RED_CLICK: 2057, //企业监控 -企业动态-全部已读
  CHOOSE_PACKAGE_PAGE_CLICK: 2093, //头部浮窗-点击立即开通-跳转选择套餐
  PRODUCTS_SERVICES_HEADER_BOX_CENTER_EXPOSURE: 2124, //登陆后页面 产品服务浮窗曝光
  PRODUCTS_SERVICES_HEADER_BOX_CENTER_CLICK: 2125, //登陆后页面 产品服务-产品点击
};
